<template>
    <modal-centered-base
    :title="title"
    :titleIcon="'phone'"
    :negative="negative"
    :leftButtonText="leftButtonText"
    :rightButtonText="rightButtonText"
    :triggerClose="triggerClose"
    :rightButtonIcon="'check-line'"
    @hideMe="emit('hideMe')"
    @clicked="emit('hideMe')"
    @rightButtonClicked="emit('rightButtonClicked')">
        <div class="phone-numbers-container">
            <!-- RadioGroup With Phone Numbers-->
            <selectors-radio-group
            verticalDirection
            :radioParams="phoneNumbersParsedList"
            @clicked="phoneNumberClicked($event)"/>
        </div>
    </modal-centered-base>
</template>

<script setup>
import ModalCenteredBase from '@/components/generic/modals/centered/Base'
import SelectorsRadioGroup from '@/components/generic/selectors/radio/RadioGroup'

/* Assets  */
import { onMounted, ref } from 'vue'

/* Emmitters */
const emit = defineEmits(['hideMe', 'rightButtonClicked', 'updatePhoneNumber'])

/* Props
@title {String} - modal title
@text {String} - modal text
@negative {Boolean} - prop to apply title & right button negative styles
@leftButtonText {String} - text for left button, this button has a default text if this is not passed
@rightButtonText {String} - text for right button
@contactList {Array} - Array with contact list
@triggerClose {Boolean} - prop to trigger close of modal
*/
const props = defineProps({
	title: String,
    text: String,
    negative: Boolean,
    leftButtonText: String,
    rightButtonText: String,
    contactList: Array,
    triggerClose: Boolean
})

const phoneNumbersParsedList = ref([])

const phoneNumberClicked = phoneNumber => {
    let phoneNumberFixed

    phoneNumbersParsedList.value.forEach(obj => {
        obj.selected = obj.id === phoneNumber
        if (obj.id === phoneNumber) phoneNumberFixed = obj.contact
    })

    emit('updatePhoneNumber', phoneNumberFixed)
}

onMounted(() => {
    phoneNumbersParsedList.value = props.contactList.map(element => {
        return {
            groupName: 'phoneNumbers',
            id: `${element.contact}${element.type}`,
            contact: element.contact,
            text: element.contact,
            selected: element.default
        }
    })
})
</script>

<style lang="scss" scoped>
.phone-numbers-container {
    width:100%;
    padding-top: 22px;

    display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;
}
</style>
